import { MapPin, Briefcase,  User, Share2 } from "../../../Atoms/Icons";
import { isNewJob, buildMailto } from "../../../static/jobsHelpers";
import { getDepartmentLabel, getLocationLabel } from "../../../static/filterOptions";

// Colored hero banner — styled after the reference screenshot, but using
// the site's own brand green (var(--vm-green)) instead of orange so it
// matches everything else. Want a different color? It's one class:
// .job-hero-banner in styles/careers.css.
export default function JobHeader({ job, onShare }) {
  return (
    <section className="job-hero-banner">
      <div className="containers-min mx-auto px-4 ">
        <div className="flex flex-wrap gap-2 mb-3">
          <span className="badge-dept ">{getDepartmentLabel(job.department)}</span>
          <span className="badge-type">{job.employmentTypeShort}</span>
          {isNewJob(job) && <span className="badge-new">New</span>}
        </div>

        <h1 className="text-3xl font-bold mb-4">{job.title}</h1>

        <div className="flex flex-wrap gap-x-6 gap-y-2 mb-6">
          <div className="meta-chip"><User size={16} /> {job.experience}</div>
          <div className="meta-chip"><MapPin size={16} /> {getLocationLabel(job.location)}</div>
          <div className="meta-chip"><Briefcase size={16} /> {job.employmentTypeShort}</div>
        </div>

        <div className="flex gap-2 flex-wrap items-center">
          <a href={buildMailto(job)} className="btn-brand">Apply Now</a>
          <span className="flex items-center gap-2 ml-0 lg:ml-2">
            <span className="share-label text-sm hidden sm:inline">Share:</span>
            <button
              type="button"
              onClick={onShare}
              className="share-btn share-btn-whatsapp"
              aria-label="Share this job"
            >
              <Share2 size={18} />
            </button>
          </span>
        </div>
      </div>
    </section>
  );
}
